import { Button } from 'components/ui/button';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { deleteDialogue } from 'store/slices/podcastResponse';

interface DeleteMessageProps {
  setOpenDelete: (value: boolean) => void;
  index: number;
}

const DeleteMessage = ({ setOpenDelete, index }: DeleteMessageProps) => {
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(false); // to check for mobile

  useEffect(() => {
    if (window.innerWidth < 640) {
      setIsMobile(true);
    }
  }, [window.innerWidth]);

  const { data } = useSelector((state: RootState) => state.podcastRes);
  const handleDeleteMessage = (index: number) => {
    dispatch(deleteDialogue(index));
    setOpenDelete(false);
    toast.success('deleted successfully!');
  };

  if (isMobile) {
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50 p-4">
        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-[90%] sm:max-w-[296px]">
          <h1 className="text-xl text-left font-bold text-[#1A211E]">
            Delete this dialogue?
          </h1>
          <p className="text-[#000A07A0] mt-2 text-left text-[13px] font-normal">
            Are you sure you want to delete this dialogue? Once it is deleted,
            it cannot be undone.
          </p>
          <div className="flex flex-row justify-end mt-6 w-full gap-2">
            <Button
              variant="customSecondary"
              size="sm"
              onClick={() => setOpenDelete(false)}
              className="text-[14px]"
            >
              Cancel
            </Button>

            <Button
              variant="customPrimary"
              size="sm"
              className="text-[14px]"
              onClick={() => handleDeleteMessage(index)}
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="absolute z-10 top-[56px] border-[1px] bg-white rounded-lg shadow-lg py-4 px-4 w-[296px] flex flex-col gap-1">
      <h1 className="text-xl text-left font-bold text-[#1A211E]">
        Delete this dialogue?
      </h1>
      <p className="text-[#000A07A0] max-w-[296px] mt-2 text-left text-[13px] font-normal">
        Are you sure you want to delete this dialogue. Once it is deleted it
        cannot be un-done.
      </p>
      <div className="flex flex-row justify-end mt-6 w-full gap-2">
        <Button
          variant="customSecondary"
          size="sm"
          onClick={() => {
            setOpenDelete(false);
          }}
          className="text-[14px]"
        >
          Cancel
        </Button>

        <Button
          variant="customPrimary"
          size="sm"
          className="text-[14px]"
          onClick={() => handleDeleteMessage(index)}
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default DeleteMessage;
